import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import { EDIT_CHECKLIST_VERSION_MUTATION } from 'src/graphql/checklist/mutation';

export default () => {
  const [editChecklistVersion] = useMutation(EDIT_CHECKLIST_VERSION_MUTATION);

  return useCallback(
    ({ checklistId, effectiveDate, checklistSections, ...rest }) =>
      editChecklistVersion({
        variables: {
          checklistId,
          effectiveDate: effectiveDate || null,
          checklistSections: (checklistSections || []).map(
            ({ questions, ...section }) => ({
              ...section,
              questions: (questions || []).map(
                ({ nestingLevel, ...question }) => question,
              ),
            }),
          ),
          ...rest,
        },
      }),
    [],
  );
};
